"use client";

import { config } from "@/chain/config";
import { SidebarProvider } from "@/components/ui";
import { WagmiProvider } from "wagmi";
import { QueryClientProvider } from "./QueryProvider";
import { ThemeProvider } from "./ThemeProvider";

type AppProviderProps = {
  children: React.ReactNode;
};

export function AppProvider({ children }: Readonly<AppProviderProps>) {
  return (
    <WagmiProvider config={config} reconnectOnMount={true}>
      <QueryClientProvider>
        <ThemeProvider attribute="class" enableSystem>
          <SidebarProvider>{children}</SidebarProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
